/**
 * English (UK) labels for the platform settings of the `core` module, and the messages used by the settings,
 * branding, files and platform routes (Phase 0 task T3a). Kept in its own file and spread into `enGB`.
 *
 * Settings labels follow `settings.<module>.<path>` (the portal renders its generic form from these).
 * The tenant `core` labels already live in en-GB.ts; this file adds the platform ones and the logo field.
 */
export const settingsEnGB = {
    // Tenant core settings: the field the logo upload fills in
    'settings.core.branding.logoFileId': 'Logo file',
    // Platform core settings
    'settings.core.auth': 'Sign-in and sessions',
    'settings.core.auth.passwordMinLength': 'Minimum password length',
    'settings.core.auth.maxFailedLogins': 'Failed sign-ins before an account is locked (0 = never lock)',
    'settings.core.auth.lockoutMinutes': 'Minutes an account stays locked',
    'settings.core.auth.sessionIdleMinutes': 'Sign out after this many idle minutes',
    'settings.core.auth.sessionMaxHours': 'Longest a session can last (hours)',
    'settings.core.auth.inviteValidHours': 'Hours an invitation link works',
    'settings.core.auth.orphanAccountDays': 'Days before a sign-in account that belongs to no organisation is deleted (0 = keep)',
    'settings.core.auth.passwordResetValidMinutes': 'Minutes a password reset link works',
    'settings.core.email.fromAddress': 'Sender email address',
    'settings.core.email.fromName': 'Sender name',
    'settings.core.email.maxAttempts': 'Attempts before an email is marked as failed',
    'settings.core.jobs': 'Background jobs',
    'settings.core.jobs.keepDoneDays': 'Keep finished jobs for this many days (0 = forever)',
    'settings.core.jobs.keepEventsDays': 'Keep published events for this many days (0 = forever)',
    'settings.core.files': 'Files',
    'settings.core.files.signedUrlSeconds': 'Seconds a download link works',
    'settings.core.files.maxUploadMb': 'Largest upload allowed (MB)',
    'settings.core.files.deviceSignedUrlSeconds': 'Seconds a kiosk download link works',
    'settings.core.realtime': 'Live updates',
    'settings.core.realtime.revalidateSeconds': 'Re-check live connections every (seconds, 0 = only when they subscribe)',
    // Errors raised by the settings, branding, files and platform routes
    'error.file_too_large': 'That file is too large.',
    'error.file_type': 'Use a PNG, JPEG or SVG image.',
    'error.svg_unsafe': 'That SVG contains scripts or links that are not allowed. Export a plain image and try again.',
    'error.module_dependency': 'Switch on "{requires}" first: "{module}" needs it.',
    'error.module_dependents': 'Switch off "{dependent}" first: it needs "{module}".',
    'error.cannot_remove_self': 'You cannot remove yourself.',
    'error.last_platform_admin': 'There must always be at least one platform administrator.',
    'error.job_not_failed': 'Only a failed job can be retried.',
};
//# sourceMappingURL=settings-en-GB.js.map